import { render, staticRenderFns } from "./houseManage.vue?vue&type=template&id=2bce02f6&scoped=true&"
import script from "./houseManage.vue?vue&type=script&lang=js&"
export * from "./houseManage.vue?vue&type=script&lang=js&"
import style0 from "./houseManage.vue?vue&type=style&index=0&id=2bce02f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce02f6",
  null
  
)

export default component.exports